export const DEFAULT_LEARN_MORE_URL = 'https://faq.allwhere.co/hc/en-us/articles/36405487042964-Beta-Integration-with-Jamf-Pro'; 
